import { loadView } from '@/router'
import application from './application'
import authentication from './authentication'
import dashboards from './dashboards'
import legacy from './legacy'

export default [
  {
    path: '/',
    component: loadView('Landing')
  },
  ...application,
  ...authentication,
  ...dashboards,
  ...legacy,
  {
    path: '*',
    component: loadView('NotFound')
  }
]
